import { MrbBaseRouteStore } from "mrb/core";
import { StationService } from "common/services";

class StationListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(StationService);
    }

    async findStations(params) {
        const response = await this.service.find(params);
        return response.data;
    }

    async deleteStation(resource) {
        const response = await this.service.delete(resource);
        return response.data;
    }
}

export default StationListRouteStore;
